import React, { createContext, useContext, useEffect } from 'react';
import useLocalStorage from './useLocalStorage';
import { IItemsCart } from 'src/features/cart/hooks/useCart';
import { IStorageArticle } from 'src/utils/getTotalPriceCart';

interface CartContextType {
  cart: IStorageArticle[];
  setCart: (value: IStorageArticle[]) => void;
}

const CartContext = createContext<CartContextType | undefined>(undefined);

interface CartProviderProps {
  children: React.ReactNode;
}

export const CartProvider: React.FC<CartProviderProps> = ({ children }) => {
  const [cart, setCart] = useLocalStorage<IStorageArticle[]>('cart', []);

  useEffect(() => {
    const filteredCart = cart.filter((item) => item.shop_id !== undefined);
    if (filteredCart.length !== cart.length) {
      setCart(filteredCart);
    }
  }, [cart, setCart]);

  return <CartContext.Provider value={{ cart, setCart }}>{children}</CartContext.Provider>;
};

export const useLocalCartContext = (): CartContextType => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};
